import { createSlice } from "@reduxjs/toolkit";
import { registerUser, userLogin, userLogout, VerifyEmail, ResendVerificationCode } from "../authAction/authAction";

const accessToken = localStorage.getItem('accessToken') ? localStorage.getItem('accessToken') : null;

const initialState = {
  loading: false,
  accessToken,
  error: null,
  success: false,
  userInfo: null, // Add userInfo field to store user information
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {},
  setCredentials: (state, { payload }) => {
    state.userInfo = payload
  },
  clearCredentials: (state) => {
    state.accessToken = null;
    state.userInfo = null;
  },
  extraReducers: {
    [userLogin.pending]: (state) => {
      state.loading = true
      state.error = null
    },
    [userLogin.fulfilled]: (state, { payload }) => {
      state.loading = false
      state.success = true
      state.accessToken = payload.accessToken
      state.userInfo = payload
    },
    [userLogin.rejected]: (state, { payload }) => {
      state.loading = false
      state.error = payload
      state.success = false
    },

    [registerUser.pending]: (state) => {
      state.loading = true
      state.error = null
    },
    [registerUser.fulfilled]: (state, { payload }) => {
      state.loading = false
      state.success = true
      state.userInfo = payload
    },
    [registerUser.rejected]: (state, { payload }) => {
      state.loading = false
      state.error = payload
      state.success = false
    },
    [userLogout.fulfilled]: (state) => {
      state.accessToken = null;
      state.userInfo = null;
    },
    [userLogout.rejected]: (state, { payload }) => {
      state.error = payload;
    },
    [VerifyEmail.fulfilled]: (state, {payload}) => {
      state.success = true
      state.loading = false
      state.error = payload
      state.userInfo = payload
    },
    [VerifyEmail.rejected]: (state, { payload }) => {
      state.error = payload
      state.success = false
      state.loading = false
    },
    [VerifyEmail.pending]: (state) => {
      state.loading = true
      state.error = null
    },
    [ResendVerificationCode.fulfilled]: (state, {payload}) => {
      state.success = true
      state.error = payload
    },
    [ResendVerificationCode.rejected]: (state, { payload }) => {
      state.error = payload
      state.success = false
      state.loading = false
    },
    
  },
});

export const { setCredentials, clearCredentials  } = authSlice.actions
export default authSlice.reducer;

